import { getCookie } from '@jouzen/ecom-utils';
import { env } from 'next-runtime-env';

import { decodeTokenToEmail } from '@/utils/decodeToken';

interface GetEmailFromSessionResponse {
  email: string;
  type: string;
}

export const getEmailFromSession = (): GetEmailFromSessionResponse => {
  const isNotProd = env('NEXT_PUBLIC_OURA_ENV') !== 'production';
  const fakeSession = getCookie('fake_session');
  const session = getCookie('session');

  if (fakeSession && isNotProd) {
    return { email: fakeSession, type: 'fake_session' };
  }

  if (session) {
    return { email: decodeTokenToEmail(session), type: 'session' };
  }

  return { email: '', type: '' };
};
